// extracted by mini-css-extract-plugin
export default {"form":"MZxilJIAyM8ZZL9QG3VL","applePayButton":"RMDK3xu96vCxG7eA2P9X","divider":"Qw09SCqMS9GnjswTj5Ea"};